import React from 'react'

function Reports() {
  return <h1 className="text-6xl">{'<Reports />'}</h1>
}

export default Reports
